module.exports = __webpack_public_path__ + "img/ball_0.828fe16b.png";